<template>
    <v-tabs v-model="year">
        <v-tab value="1" href="#1" style="justify-content: left"> Exercice N </v-tab>
        <v-tab
            value="2"
            href="#2"
            style="justify-content: left"
            v-if="parameters.periodsNumber > 1"
        >
            Exercice N+1
        </v-tab>
        <v-tab
            value="3"
            href="#3"
            style="justify-content: left"
            v-if="parameters.periodsNumber > 2"
        >
            Exercice N+2
        </v-tab>
        <v-tab
            value="4"
            href="#4"
            style="justify-content: left"
            v-if="parameters.periodsNumber > 3"
        >
            Exercice N+3
        </v-tab>
        <v-tab
            value="5"
            href="#5"
            style="justify-content: left"
            v-if="parameters.periodsNumber > 4"
        >
            Exercice N+4
        </v-tab>
    </v-tabs>
    <v-tabs-window v-model="year">
        <v-window-item value="1">
            <v-data-table
                :items="detailsItems[0]"
                :headers="detailsHeaders"
                :itemsPerPage="detailsItems[0].length"
                hide-default-footer
                class="table"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            {{ props.item.title }}
                        </td>
                        <td
                            v-for="monthIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                            :key="props.item.months[monthIndex].date"
                            class="pl-0 pr-1 py-0 ma-0"
                        >
                            <oss-text-field-filled
                                hide-details
                                :disabled="!props.item.editable"
                                @change="updateWhenWorkForceChange(monthIndex)"
                                v-model="props.item.months[monthIndex].amount"
                            />
                        </td>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            <oss-text-field-filled
                                hide-details
                                :disabled="props.index === 1"
                                v-model="props.item.total"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-window-item>
        <v-window-item value="2">
            <v-data-table
                :items="detailsItems[1]"
                :headers="detailsHeaders"
                :itemsPerPage="detailsItems[1].length"
                hide-default-footer
                class="table"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            {{ props.item.title }}
                        </td>
                        <td
                            v-for="monthIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                            :key="props.item.months[monthIndex].date"
                            class="pl-0 pr-1 py-0 ma-0"
                        >
                            <oss-text-field-filled
                                hide-details
                                :disabled="!props.item.editable"
                                @change="updateWhenWorkForceChange(monthIndex)"
                                v-model="props.item.months[monthIndex].amount"
                            />
                        </td>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            <oss-text-field-filled
                                hide-details
                                :disabled="props.index === 1"
                                v-model="props.item.total"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-window-item>
        <v-window-item value="3">
            <v-data-table
                :items="detailsItems[2]"
                :headers="detailsHeaders"
                :itemsPerPage="detailsItems[2].length"
                hide-default-footer
                class="table"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            {{ props.item.title }}
                        </td>
                        <td
                            v-for="monthIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                            :key="props.item.months[monthIndex].date"
                            class="pl-0 pr-1 py-0 ma-0"
                        >
                            <oss-text-field-filled
                                hide-details
                                :disabled="!props.item.editable"
                                @change="updateWhenWorkForceChange(monthIndex)"
                                v-model="props.item.months[monthIndex].amount"
                            />
                        </td>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            <oss-text-field-filled
                                hide-details
                                :disabled="props.index === 1"
                                v-model="props.item.total"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-window-item>
        <v-window-item value="4">
            <v-data-table
                :items="detailsItems[3]"
                :headers="detailsHeaders"
                :itemsPerPage="detailsItems[3].length"
                hide-default-footer
                class="table"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            {{ props.item.title }}
                        </td>
                        <td
                            v-for="monthIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                            :key="props.item.months[monthIndex].date"
                            class="pl-0 pr-1 py-0 ma-0"
                        >
                            <oss-text-field-filled
                                hide-details
                                :disabled="!props.item.editable"
                                @change="updateWhenWorkForceChange(monthIndex)"
                                v-model="props.item.months[monthIndex].amount"
                            />
                        </td>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            <oss-text-field-filled
                                hide-details
                                :disabled="props.index === 1"
                                v-model="props.item.total"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-window-item>
        <v-window-item value="5">
            <v-data-table
                :items="detailsItems[4]"
                :headers="detailsHeaders"
                :itemsPerPage="detailsItems[4].length"
                hide-default-footer
                class="table"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            {{ props.item.title }}
                        </td>
                        <td
                            v-for="monthIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                            :key="props.item.months[monthIndex].date"
                            class="pl-0 pr-1 py-0 ma-0"
                        >
                            <oss-text-field-filled
                                hide-details
                                :disabled="!props.item.editable"
                                @change="updateWhenWorkForceChange(monthIndex)"
                                v-model="props.item.months[monthIndex].amount"
                            />
                        </td>
                        <td class="pl-0 pr-1 py-0 ma-0">
                            <oss-text-field-filled
                                hide-details
                                :disabled="props.index === 1"
                                v-model="props.item.total"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-window-item>
    </v-tabs-window>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Emit } from "vue-facing-decorator";

@Component
export class StaffDetails extends Vue {
    // PROPS

    @Prop({ default: null }) staff: any;
    @Prop({ default: null }) parameters: any;
    // @Prop({default: null})study: any;
    @Prop({ default: moment().startOf("month").format() }) date: string;

    // ATTRIBUTES

    year: string = "1";

    // ITEMS & HEADERS

    get detailsHeaders() {
        const detailsHeaders = [
            { title: "Titre", value: "" },
            { title: "Totaux", value: "" },
        ];
        const monthList = this.orderedMonthsPeriods[parseInt(this.year) - 1]; // use v-tab attribute year to get the current period
        for (let monthIndex = 0; monthIndex < monthList.length; monthIndex++) {
            // insertion of each month in headers list at index monthIndex+1 to be between the 2 existing columns
            const headerLine = { title: monthList[monthIndex], value: "" };
            detailsHeaders.splice(monthIndex + 1, 0, headerLine);
        }
        return detailsHeaders;
    }

    buildYearlyDetailsItems(key, previousDetails) {
        // build or rebuild data structure every time the budget is loaded or a yearly total from main component is modified
        if (key + 1 > this.staff.years.length) {
            // years not used
            return [];
        }
        const yearlyDetailsItems = this.buildYearlyDetailsItemsFromScratch(key);
        if (!previousDetails || previousDetails.length === 0) {
            // first building at the creation of the budget, TO PUT IN CP ?
            return yearlyDetailsItems;
        }
        // for the workforce, instead of the yearly total, there is no need to rebuild the unedited columns at the end, they are already set to the correct value
        for (let monthIndex = 0; monthIndex < previousDetails[0].months.length; monthIndex++) {
            // we could have taken yearlyDetailsItems to reference the indexes instead of previousDetails
            if (previousDetails[0].months[monthIndex].edited) {
                // value to keep is the amount, computing the new saisonnalities, but not updating the other columns yet to reduce computation time
                this.markEditedValues(yearlyDetailsItems, monthIndex);
                yearlyDetailsItems[0].months[monthIndex].amount =
                    previousDetails[0].months[monthIndex].amount;
                yearlyDetailsItems[2].months[monthIndex].amount =
                    yearlyDetailsItems[0].months[monthIndex].amount *
                    yearlyDetailsItems[1].months[monthIndex].amount;
            }
        }
        yearlyDetailsItems[0].total = this.averageYearlyWorkForce(yearlyDetailsItems[0].months);
        yearlyDetailsItems[2].total = this.computeLineSum(yearlyDetailsItems[2]);
        this.staff.years[key].totalAmount = yearlyDetailsItems[2].total;
        return yearlyDetailsItems;
    }

    buildYearlyDetailsItemsFromScratch(key) {
        // construction of the details at the creation of a budget, if there is no previous values
        let yearlyDetailsItems = [];
        const monthList = this.orderedMonthsPeriods[key];
        let monthsNumber = monthList.length;
        let numberToReplace = this.staff.number;
        let monthlyGrossSalary = this.round(this.staff.years[key].individualAmount / 12, 0);
        let monthsWorkForce = [];
        for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
            const month = {
                amount: numberToReplace,
                date: monthList[monthIndex],
                edited: false,
                manuallyModified: false,
            };
            monthsWorkForce.push(month);
        }
        let workForce = {
            title: "Effectif",
            total: this.averageYearlyWorkForce(monthsWorkForce),
            months: monthsWorkForce,
            uneditedCount: monthsWorkForce.length,
            editable: true,
        };
        yearlyDetailsItems.push(workForce);
        let monthsGrossSalary = [];
        let yearlyGrossSalary = monthsNumber * monthlyGrossSalary;
        for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
            const month = {
                amount: monthlyGrossSalary,
                date: monthList[monthIndex],
                edited: false,
                manuallyModified: false,
            };
            monthsGrossSalary.push(month);
        }
        let monthlyGrossSalaries = {
            title: "Salaire mensuel individuel brut",
            total: yearlyGrossSalary,
            months: monthsGrossSalary,
            uneditedCount: monthsGrossSalary.length,
            editable: false,
        };
        yearlyDetailsItems.push(monthlyGrossSalaries);
        let monthsGlobalGrossSalary = [];
        let yearlyGlobalGrossSalary = 0;
        for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
            const monthlyGlobalGrossSalary =
                monthsWorkForce[monthIndex].amount * monthlyGrossSalary;
            yearlyGlobalGrossSalary += monthlyGlobalGrossSalary;
            const month = {
                amount: monthlyGlobalGrossSalary,
                date: monthList[monthIndex],
                edited: false,
                manuallyModified: false,
            };
            monthsGlobalGrossSalary.push(month);
        }
        let monthlyGlobalGrossSalaries = {
            title: "Masse salariale mensuelle brut",
            total: yearlyGlobalGrossSalary,
            months: monthsGlobalGrossSalary,
            uneditedCount: monthsGlobalGrossSalary.length,
            editable: false,
        };
        yearlyDetailsItems.push(monthlyGlobalGrossSalaries);
        return yearlyDetailsItems;
    }

    get detailsItems() {
        // copying current the values of detailsItems needed to rebuild detailsItems without loss
        const previousDetails = JSON.parse(JSON.stringify(this.staff.details));
        this.staff.details = [
            this.buildYearlyDetailsItems(0, previousDetails[0]),
            this.buildYearlyDetailsItems(1, previousDetails[1]),
            this.buildYearlyDetailsItems(2, previousDetails[2]),
            this.buildYearlyDetailsItems(3, previousDetails[3]),
            this.buildYearlyDetailsItems(4, previousDetails[4]),
        ];
        return this.staff.details;
    }

    set detailsItems(value) {
        this.staff.details = value;
    }

    // METHODS

    get orderedMonthsFirstPeriod() {
        let orderedMonthsFirstPeriod = [];
        let currentMonth = moment(this.date).format("MMMM YYYY");
        orderedMonthsFirstPeriod.unshift(currentMonth);
        for (let month = 1; month < this.parameters.firstPeriodMonthsNumber; month++) {
            currentMonth = moment(currentMonth, "MMMM YYYY").add(1, "months").format("MMMM YYYY");
            orderedMonthsFirstPeriod.push(currentMonth);
        }
        return orderedMonthsFirstPeriod;
    }

    get orderedMonthsPeriods() {
        // creation of the month list of each accountingPeriod
        let orderedMonthsPeriods = [];
        orderedMonthsPeriods.unshift(this.orderedMonthsFirstPeriod); // creation of the first period is different because it may contains more than 12 months
        for (let year = 1; year < this.parameters.periodsNumber; year++) {
            let orderedMonthsCurrentPeriod = [];
            const previousYearLastMonthIndex =
                year === 1 ? this.parameters.firstPeriodMonthsNumber - 1 : 11;
            let currentMonth = moment(
                orderedMonthsPeriods[year - 1][previousYearLastMonthIndex],
                "MMMM YYYY",
            )
                .add(1, "months")
                .format("MMMM YYYY"); // get the first month of the current period
            orderedMonthsCurrentPeriod.unshift(currentMonth);
            for (let month = 1; month < this.parameters.firstPeriodMonthsNumber; month++) {
                currentMonth = moment(currentMonth, "MMMM YYYY")
                    .add(1, "months")
                    .format("MMMM YYYY");
                orderedMonthsCurrentPeriod.push(currentMonth);
            }
            orderedMonthsPeriods.push(orderedMonthsCurrentPeriod);
        }
        return orderedMonthsPeriods;
    }

    get monthlyTotalGrossSalaries() {
        const monthlyTotalGrossSalaries = [];
        const staffDetailsFirstYear = this.staff.details[0];
        for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
            const monthlyTotalGrossSalary =
                staffDetailsFirstYear[0].months[monthIndex].amount *
                staffDetailsFirstYear[1].months[monthIndex].amount;
            monthlyTotalGrossSalaries.push(monthlyTotalGrossSalary);
        }
        return monthlyTotalGrossSalaries;
    }

    get yearlyTotalGrossSalary() {
        let salarySum = 0;
        for (const salary of this.detailsItems[0][2]) {
            salarySum += salary;
        }
        return salarySum;
    }

    averageYearlyWorkForce(months) {
        let average = 0;
        const length = months.length;
        for (const month of months) {
            average += month.amount;
        }
        average /= length;
        return this.round(average, 1);
    }

    computeLineSum(line) {
        let sum = 0;
        for (const month of line.months) {
            sum += month.amount;
        }
        return this.round(sum, 1);
    }

    markEditedValues(yearlyDetails, monthIndex) {
        for (let lineIndex = 0; lineIndex < yearlyDetails.length; lineIndex++) {
            yearlyDetails[lineIndex].months[monthIndex].edited = true;
            yearlyDetails[lineIndex].months[monthIndex].manuallyModified = lineIndex === 0;
            yearlyDetails[lineIndex].uneditedCount -= 1;
        }
    }

    @Emit("store-active-details")
    updateWhenWorkForceChange(monthIndex) {
        const yearlyDetails = this.detailsItems[parseInt(this.year) - 1];
        this.markEditedValues(yearlyDetails, monthIndex);
        yearlyDetails[0].total = this.averageYearlyWorkForce(yearlyDetails[0].months);
        yearlyDetails[2].months[monthIndex].amount =
            yearlyDetails[0].months[monthIndex].amount * yearlyDetails[1].months[monthIndex].amount;
        yearlyDetails[2].total = this.computeLineSum(yearlyDetails[2]);
        this.staff.years[parseInt(this.year) - 1].totalAmount = yearlyDetails[2].total;
        const pathToActive = {
            item: this.staff,
            itemType: "staff",
            yearIndex: parseInt(this.year) - 1,
            monthIndex: monthIndex,
            valueToReport: yearlyDetails[0].months[monthIndex].amount,
        };
        return pathToActive;
    }

    round(number, decimalNumber) {
        const factor = Math.pow(10, decimalNumber);
        return Math.round(number * factor) / factor;
    }
}

export default toNative(StaffDetails);
</script>

<style></style>
